import React from 'react';
import { Card, Empty } from '../bi/BiUi';

export const STATES = [
  ['present', '🟢 Present', 'bg-emerald-500 text-slate-950 border-emerald-400'],
  ['absent', '🔴 Absent', 'bg-rose-500 text-white border-rose-400'],
  ['leave', '🟡 Approved Leave', 'bg-amber-400 text-slate-950 border-amber-300']
];
export const inputCls = 'w-full rounded-lg border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-slate-100 placeholder-slate-500 outline-none focus:border-cyan-400';

/** Section A: 3-state pill attendance grid with optional note and Mark All Present. */
export default function AttendanceSection({ students, visible, att, search, setSearch, setStatus, setNote, markAllPresent }) {
  return (
    <Card title="A. Quick Attendance" subtitle="Tap a state; add an optional note for absence or leave"
      right={<div className="flex gap-2">
        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search name / roll" className={`${inputCls} !w-40`} />
        <button type="button" onClick={markAllPresent} className="rounded-lg bg-emerald-500 px-3 py-1.5 text-xs font-bold text-slate-950">Mark All Present</button>
      </div>}>
      {!students.length ? <Empty>No students in this class.</Empty> : (
        <ul className="divide-y divide-slate-800">
          {visible.map((s) => {
            const a = att[s._id] || { status: 'present', note: '' };
            return (
              <li key={s._id} className="flex flex-wrap items-center gap-2 py-2">
                <span className="w-10 text-xs text-slate-500">{s.rollNumber || '-'}</span>
                <span className="min-w-[8rem] flex-1 text-sm font-medium">{s.name}</span>
                <div className="flex gap-1" role="group" aria-label={`Attendance for ${s.name}`}>
                  {STATES.map(([v, label, on]) => (
                    <button key={v} type="button" aria-pressed={a.status === v} onClick={() => setStatus(s._id, v)}
                      className={`rounded-full border px-3 py-1 text-xs font-semibold transition ${a.status === v ? on : 'border-slate-700 text-slate-400 hover:bg-slate-800'}`}>{label}</button>
                  ))}
                </div>
                {a.status !== 'present' && (
                  <input value={a.note} onChange={(e) => setNote(s._id, e.target.value)} maxLength={200}
                    placeholder={a.status === 'leave' ? 'Leave reason (e.g. fever)' : 'Reason (optional)'} className={`${inputCls} !w-52`} />
                )}
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
